import * as React from "react";
import { forwardRef } from "react";
const SvgEnlarge = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	fill: "none",
	height: "1em",
	viewBox: "0 0 13 12",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M0.333374 12V6.85714H2.04766V10.2857H5.47623V12H0.333374ZM10.6191 5.14286V1.71429H7.19052V0H12.3334V5.14286H10.6191Z",
	fill: "currentColor"
}));
const ForwardRef = forwardRef(SvgEnlarge);
export default ForwardRef;
